// @flow
import styles from './JobMailWrapper.less';

import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import classnames from 'classnames';

import { Card, MailIcon, Text } from 'seek-style-guide/react';
import JobMail from './JobMail';

import { states } from 'src/store/saveSearch/saveSearch';

type Props = {
  position: JobMailPosition,
  successfullySignedUp: boolean
};

const mapStateToProps = ({ saveSearch }) => ({
  successfullySignedUp: saveSearch.status === states.SAVED
});

class JobMailWrapper extends PureComponent<Props> {
  props: Props;

  render() {
    const { position, successfullySignedUp } = this.props;

    const rootClasses = classnames({
      [styles.root]: true,
      [styles.top]: position === 'top',
      [styles.bottom]: position === 'bottom'
    });

    return (
      <div>
        <Card
          transparent
          className={rootClasses}
          data-automation="jobMailPanel"
        >
          <Text subheading regular raw>
            <MailIcon className={styles.icon} svgClassName={styles.iconSvg} />
          </Text>
          {!successfullySignedUp && (
            <Text subheading regular className={styles.savePrompt}>
              <h1>Receive new jobs for this search by email</h1>
            </Text>
          )}
          <div className={styles.form}>
            <JobMail position={position} />
          </div>
        </Card>
      </div>
    );
  }
}

export default connect(mapStateToProps)(JobMailWrapper);
